import DashboardCard from "../components/DashboardCard";
import RecentPostsWidget from "../components/RecentPostsWidget";
import TopPostsWidget from "../components/TopPostsWidget";
import QuickActionsWidget from "../components/QuickActionsWidget";
import BannerPerformanceWidget from "../components/BannerPerformanceWidget";
import useDashboard from "../hooks/useDashboard";
import { useTheme } from "../../context/ThemeContext";

export default function DashboardPage() {

  const { isDark } = useTheme();


  const {data, loading, error} = useDashboard();

  const stats = [
    {
      title: "Posts",
      value: data?.summary?.total_posts ?? 0,
      subtitle: `${data?.summary?.published_posts ?? 0} published`,
    },

    {
      title: "Views",
      value: data?.summary?.total_views ?? 0,
      subtitle: `${data?.summary?.unique_visitors ?? 0} visitors`,
    },

    {
      title: "CTA Events",
      value: data?.summary?.total_cta_events ?? 0,
    },

    {
      title: "Banner Clicks",
      value: data?.summary?.total_banner_clicks ?? 0,
      subtitle: `${data?.summary?.total_banner_impressions ?? 0} impressions`,
    },
  ];

  


  const banners = [
  {
    id: 1,
    title: "WorkEikon CTA",
    impressions: 2400,
    clicks: 120,
    ctr: 5.0,
  },
  {
    id: 2,
    title: "Quinthex Campaign",
    impressions: 1800,
    clicks: 65,
    ctr: 3.6,
  },
  {
    id: 3,
    title: "Fundtz Promotion",
    impressions: 900,
    clicks: 20,
    ctr: 2.2,
  },
];

  return (
    <div className="space-y-10">

      <div>

        <span
          className={`
            text-sm
            tracking-[0.2em]
            uppercase
            ${
              isDark
                ? "text-gray-400"
                : "text-gray-500"
            }
          `}
        >
          Dashboard
        </span>

        <h1
          className="
            mt-2
            text-5xl
            font-bold
          "
        >
          Content Overview
        </h1>

      </div>

      {/* KPI CARDS */}

      <div
        className="
          grid
          grid-cols-1
          md:grid-cols-2
          xl:grid-cols-4
          gap-6
        "
      >
        {stats.map((stat) => (
          <DashboardCard
            key={stat.title}
            {...stat}
          />
        ))}
      </div>

      {/* WIDGETS */}

      <div
        className="
          grid
          grid-cols-1
          xl:grid-cols-2
          gap-6
        "
      >

        <RecentPostsWidget
          posts={data?.recent_posts}
        />

        <TopPostsWidget
          posts={data?.top_posts}
        />

      </div>

      <div
        className="
          grid
          xl:grid-cols-2
          gap-6
        "
      >

        <BannerPerformanceWidget
          banners={data?.banner_performance}
        />

        <QuickActionsWidget />

      </div>

    </div>
  );
}